export enum FEATURES {
  TOTAL_ENROLMENTS = 'totalEnrolments',
  TOTAL_WITHDRAWALS = 'totalWithdrawals',
}

export const FEATURE_FLAGS = [
  { name: FEATURES.TOTAL_ENROLMENTS, isActive: true },
  { name: FEATURES.TOTAL_WITHDRAWALS, isActive: true },
];
